import { render, staticRenderFns } from "./ChatComments.vue?vue&type=template&id=3c1f7f61&"
import script from "./ChatComments.vue?vue&type=script&lang=js&"
export * from "./ChatComments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports